// extracted by mini-css-extract-plugin
export default {"root":"LinkedReturnsTable_root__MMqvr","linkedReturn":"LinkedReturnsTable_linkedReturn__jkZbE"};